import InstallPresenter from "./InstallPresenter";
import {
  ExportEmailRequest,
  InstallationView,
  InstallationViewResponse,
  ReportDataRow,
} from "api/interfaces/reportInterface.interface";
import { useParams } from "react-router-dom";
import { useCallback, useEffect, useRef, useState } from "react";
import { useQuery } from "react-query";
import { useAppSelector } from "redux/hooks";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import {
  getInstallReportView,
  getInstallThumbnailSync,
  postSendEmailInstallation,
  putCompleteInstallReport,
} from "api/reportAPI";
import { getAccountTimeFormatDate } from "utils/timeUtil";
import { useReactToPrint } from "react-to-print";
import InstallPrintPage from "./InstallPrintPage";
import { BasePagination } from "api/interfaces/commonInterface.interface";
import { useMutation } from "react-query";
import { useQueryClient } from "react-query";
import { checkEmailRegEx } from "utils/regEx";
import NoAvailable from "components/templates/nopage/NoAvailable";
import { useMenu } from "hook/useMenu";
import { baseQueryInfo, useQueryKey } from "utils/queryUtil";
import useApiError from "hook/useApiError";
import useStatusMutation from "hook/useStatusMutation";
import useStompDebouncedRefetch, {
  StompDateSignalKey,
} from "hook/useStompDebouncedRefetch";
import { INSTALLATION_PRINT_PAGE_STYLE } from "./InstallPrintPageStyled";
import { checkEmpty } from "utils/functions";

type Props = {
  state: ReportDataRow | undefined;
};

export default function InstallContainer(props: Props): JSX.Element {
  const { menuNavigation } = useMenu(
    {}
  );
  const queryClient = useQueryClient();
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const params = useParams();
  const { lang, notifySuccess, notifyError } = useApiError();

  const componentRef = useRef<any>(null);
  //const title = props.state?.title as string;

  const [intervalMs, setIntervalMs] = useState<number>(0);
  const [confirmFinish, setConfirmFinish] = useState<boolean>(false);
  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);

  const [removedRecorder, setRemovedRecorder] = useState<boolean>(false);

  const reportId = params.reportId as string;
  const [reportTitle, setReportTitle] = useState<string>("");

  const countRef = useRef(0);

  const [installationData, setInstallationData] = useState<InstallationView>({
    recorderInfo: {
      name: "",
      installationDate: "",
      location: "",
      model: "",
      timezone: "",
    },
    cameraInfo: [],
    installationReport: {
      id: "",
      customerName: "",
      customerPhoneNumber: "",
      customerLocation: "",
      installerName: "",
      installerPhoneNumber: "",
      installerCompany: "",
      installerCompanyPhoneNumber: "",
      installerCompanyAddress: "",
      installationDate: "",
      deviceSerial: "",
      deviceDescription: "",
      analogCameraModels: [],
      updatable: true,
      targetAccountId: "",
      targetAccountName: "",
      targetAccountNumber: "",
    },
  });

  useEffect(() => {
    if (props.state) {
      setRemovedRecorder(props.state.recorderTotalCount === 0 ? true : false);
    }
  }, [props.state]);

  const [installQueryInfo, setInstallQueryInfo] = useState<BasePagination>({
    ...baseQueryInfo,
    pageLimit: 200,
    sortType: "",
  });
  const installQueryKey = useQueryKey(installQueryInfo);

  // const reportDetailInfo = useQuery(
  //   ["reportDetailInfo", reportId],
  //   () =>
  //     getReportInfoInstall({
  //       accountId: selectedAccount.accountId,
  //       reportId: reportId,
  //     }),
  //   {
  //     retry: 0,
  //     refetchOnWindowFocus: false,
  //     onSuccess: (res: any) => {
  //       if (res.result !== undefined && res.error === 0) {
  //         setReportTitle(res.result.preferences?.title);
  //       }else{
  //         setReportTitle("N/A")
  //       }
  //     },
  //     onError: (e: any) => {
  //       setReportTitle("N/A")
  //     }
  //   }
  // );

  const installListQuery = useQuery(
    ["installationRecorder", installQueryKey],
    () =>
      getInstallReportView({
        reportId: reportId,
        payload: installQueryInfo,
      }),
    {
      retry: 0,
      refetchInterval: intervalMs,
      refetchOnWindowFocus: false,
      onSuccess: (res: InstallationViewResponse) => {
        if (res.error !== 0 || res.result === undefined) {
          setIntervalMs(0);
          return;
        }
        res.result.installationReport.installationDate =
          res.result.installationReport.installationDate !== undefined
            ? getAccountTimeFormatDate(
                res.result.installationReport.installationDate,
                selectedAccount,
                // res.result.recorderInfo.timezone,
                true
              )
            : "";
        setInstallationData({
          ...res.result,
          cameraInfo: res.result.cameraInfo?.map((camera) => {
            return {
              ...camera,
              thumbnailUrl:
                camera.thumbnailUrl + "?v=" + new Date().getTime().toString(),
            };
          }),
        });

        if (intervalMs > 0) {
          countRef.current += 1;
          const waitingCamera = res.result.cameraInfo?.filter((camera) => {
            return camera.installationStatus === "WAITING";
          });

          if (waitingCamera.length === 0) {
            notifySuccess(lang.label.report.notify.install.sync.end);
            setIsRefreshing(false);
            setIntervalMs(0);
            countRef.current = 0;
          }
          // else if( countRef.current > res.result.cameraInfo.length){
          //   setIsRefreshing(false);
          //   setIntervalMs(0);
          //   countRef.current =0;
          // }
        } else if (intervalMs === 0) {
          const waitedCamera = res.result.cameraInfo?.filter((camera) => {
            return camera.installationStatus === "WAITING";
          });
          if (waitedCamera !== undefined && waitedCamera.length > 0) {
            setIntervalMs(5000);
          }
        }
      },
      onError: (e: any) => {
        setIsRefreshing(false);
        setIntervalMs(0);
        countRef.current = 0;
        // notify(
        //   "error",
        //   intl.formatMessage({
        //     id: "label.report.notify.install.list.error",
        //     defaultMessage: "Installation search error.",
        //   })
        // );
      },
    }
  );
  useStompDebouncedRefetch({
    stompKey: ["reportDetailUpdated"] as StompDateSignalKey[],
    refetch: installListQuery.refetch,
  });

  const mutationInstallThumbnailSync = useMutation(getInstallThumbnailSync, {
    onSuccess: () => {
      notifySuccess(lang.label.report.notify.install.sync.success);
      setIntervalMs(3000);
      queryClient.invalidateQueries("installationRecorder");
    },
    onError: () => {
      notifyError(lang.label.report.notify.install.sync.fail);
    },
  });

  const onClickRefresh = useCallback(() => {
    if (reportId) {
      setIsRefreshing(true);
      mutationInstallThumbnailSync.mutate({
        reportId: reportId,
      });
    }
  }, [mutationInstallThumbnailSync, reportId]);

  const print = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Installation Report",
    copyStyles: true,
    pageStyle: INSTALLATION_PRINT_PAGE_STYLE,
  });

  const onClickSearch = useCallback(
    (keyword: string) => {
      setInstallQueryInfo((query) => {
        return {
          ...query,
          keyword,
          pageNum: 0,
        };
      });
      installListQuery.refetch();
    },
    [installListQuery]
  );
  const mutationCompleteInstall = useStatusMutation(putCompleteInstallReport, {
    onSuccess: () => {
      setConfirmFinish(false);
      notifySuccess(lang.label.report.notify.install.update.complete.success);
      queryClient.invalidateQueries("installationRecorder");
    },
    onError: () => {
      notifyError(lang.label.report.notify.install.update.complete.fail);
    },
  });

  const onClickComplete = useCallback(() => {
    setConfirmFinish(true);
  }, []);

  const onConfirmCancel = useCallback(() => {
    setConfirmFinish(false);
  }, []);

  const onConfirm = useCallback(() => {
    if (reportId) {
      mutationCompleteInstall.mutate({
        reportId: reportId,
      });
    }
  }, [mutationCompleteInstall, reportId]);

  const mutationSendEmail = useMutation(postSendEmailInstallation, {
    onSuccess: () => {
      notifySuccess(lang.label.report.notify.install.emailSend.success);
      setIsSendEmail(false);
      //queryClient.invalidateQueries("installationRecorder");
    },
    onError: () => {
      notifyError(lang.label.report.notify.install.emailSend.fail);
    },
  });

  const [isSendEmail, setIsSendEmail] = useState<boolean>(false);
  const [sendMailInfo, setSendMailInfo] = useState<ExportEmailRequest>({
    email: [],
    title: "",
    message: "",
    reportId: reportId as string,
  });

  const email = useCallback(() => {
    if (reportId) {
      setIsSendEmail(true);
      setSendMailInfo({
        email: [],
        title: "",
        message: "",
        reportId: reportId as string,
      });
    }
  }, [reportId]);

  const onSelectEmail = useCallback(
    (user: string[]) => {
      setSendMailInfo({
        ...sendMailInfo,
        email: user,
      });
    },
    [sendMailInfo]
  );

  const onChangeEmailMsg = useCallback(
    (e: any) => {
      setSendMailInfo({
        ...sendMailInfo,
        message: e.target.value,
      });
    },
    [sendMailInfo]
  );

  const setIsSendEmailModal = (flag: boolean) => {
    setIsSendEmail(flag);
  };

  const [isValid, setIsValid] = useState<boolean>(true);
  const [isValidEmail, setIsValidEmail] = useState<boolean>(true);

  const onClickSendEmail = useCallback(() => {
    setIsValid(true);
    setIsValidEmail(true);
    if (sendMailInfo.email.length === 0) {
      setIsValid(false);
      return;
    }

    try {
      const isAllValid = sendMailInfo.email.every(
        (email) => !checkEmpty(email) && checkEmailRegEx(email)
      );
      if (!isAllValid) throw new Error();
    } catch (error) {
      setIsValidEmail(false);
      return;
    }

    // if (!checkInvalidEmail) {
    //   setIsValidEmail(false);
    //   return;
    // }

    mutationSendEmail.mutate({
      reportId: reportId,
      accountId: selectedAccount.accountId,
      payload: {
        email: sendMailInfo.email,
        title: sendMailInfo.title,
        message: sendMailInfo.message,
        reportId: sendMailInfo.reportId,
      },
    });
  }, [
    mutationSendEmail,
    reportId,
    selectedAccount.accountId,
    sendMailInfo.email,
    sendMailInfo.message,
    sendMailInfo.reportId,
    sendMailInfo.title,
  ]);
  const onPrint = useCallback(() => {
    const images = document.querySelectorAll("img");
    let loaded = 0;
    let settled = false;

    function tryPrint() {
      if (settled) return;
      settled = true;
      print();
    }

    const checkLoaded = () => {
      images.forEach((img) => {
        if (img.complete) {
          loaded++;
        } else {
          img.onload = img.onerror = () => {
            loaded++;
            if (loaded === images.length) tryPrint();
          };
        }
      });

      // 전부 로드된 경우
      if (loaded === images.length) {
        tryPrint();
      } else {
        //그외 3초 딜레이
        setTimeout(() => {
          tryPrint();
        }, 3000);
      }
    };

    checkLoaded();
  }, [print]);

  if (installListQuery.error) {
    return (
      <NoAvailable
        onReturn={() => menuNavigation({ to: "/reports" })}
        buttonLabel="Return to Reports"
        message="This report is no longer available"
      />
    );
  }
  return (
    <>
      <InstallPresenter
        installationData={installationData}
        title={reportTitle}
        print={onPrint}
        email={email}
        componentRef={componentRef}
        onClickRefresh={onClickRefresh}
        onClickSearch={onClickSearch}
        onClickComplete={onClickComplete}
        isSendEmail={isSendEmail}
        onSelectEmail={onSelectEmail}
        onChangeEmailMsg={onChangeEmailMsg}
        setIsSendEmailModal={setIsSendEmailModal}
        onClickSendEmail={onClickSendEmail}
        isValid={isValid}
        isValidEmail={isValidEmail}
        confirmFinish={confirmFinish}
        onConfirmCancel={onConfirmCancel}
        onConfirm={onConfirm}
        isRefreshing={isRefreshing}
        removedRecorder={removedRecorder}
        selectedAccount={selectedAccount}
        isLoading={installListQuery.isFetching || installListQuery.isLoading}
        isCompleteLoading={!mutationCompleteInstall.idle}
      />

      <InstallPrintPage
        installationData={installationData}
        title={reportTitle}
        componentRef={componentRef}
      />
    </>
  );
}
